import { EmailDeliveryFailureNotificationType, EmailDeliveryFailuresLookbackDays } from '~/services/SailthruService';

export const EMAIL_DELIVERY_FAILURES_PAGE_SIZE = 25;
export const DEFAULT_EMAIL_DELIVERY_FAILURES_LOOKBACK_DAYS: EmailDeliveryFailuresLookbackDays = 7;

export const EMAIL_DELIVERY_FAILURES_LOOKBACK_DAY_OPTIONS: Array<EmailDeliveryFailuresLookbackDays> = [7, 14, 21, 28];

export const EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPE_GROUPS = {
  cancellations: 'Cancellation emails',
  postPurchase: 'Post-purchase notifications',
  confirmations: 'Confirmation emails',
  others: 'Others',
} as const;

export const EMAIL_DELIVERY_FAILURE_CANCELLATION_NOTIFICATION_TYPES: Array<EmailDeliveryFailureNotificationType> = [
  'vendor_addon_cancellation',
  'vendor_booking_cancellation_tour',
  'vendor_cancellation_v2',
  'vendor_experience_booking_cancellation',
  'vendor_led_booking_cancelled',
];

export const EMAIL_DELIVERY_FAILURE_POST_PURCHASE_NOTIFICATION_TYPES: Array<EmailDeliveryFailureNotificationType> = [
  'transfer_update_vendor_notification',
  'vendor_bnbl_switch',
  'vendor_change_dates_confirmation_v2',
  'vendor_name_change_confirmation_v2',
  'vendor_package_upgrade_confirmation',
  'vendor_special_request_response',
  'vendor_special_request_update',
];

export const EMAIL_DELIVERY_FAILURE_CONFIRMATION_NOTIFICATION_TYPES: Array<EmailDeliveryFailureNotificationType> = [
  'cruise_order_confirmation_by_vendor',
  'vendor_add_extra_guests_confirmation',
  'vendor_addon_confirmation',
  'vendor_booking_confirmation_tour',
  'vendor_booking_confirmation_v2',
  'vendor_led_booking_confirmed',
];

export const EMAIL_DELIVERY_FAILURE_OTHER_NOTIFICATION_TYPES: Array<EmailDeliveryFailureNotificationType> = [
  'inventory_request_vendor',
  'vendor_creation_status',
  'vendor_reset_password',
  'vendor_unlogged_bookings',
];

export const EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPES: Array<EmailDeliveryFailureNotificationType> = [
  ...EMAIL_DELIVERY_FAILURE_CANCELLATION_NOTIFICATION_TYPES,
  ...EMAIL_DELIVERY_FAILURE_POST_PURCHASE_NOTIFICATION_TYPES,
  ...EMAIL_DELIVERY_FAILURE_CONFIRMATION_NOTIFICATION_TYPES,
  ...EMAIL_DELIVERY_FAILURE_OTHER_NOTIFICATION_TYPES,
];

export const EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPE_GROUP_LABELS: Record<
  EmailDeliveryFailureNotificationType,
  string
> = {
  ...Object.fromEntries(
    EMAIL_DELIVERY_FAILURE_CANCELLATION_NOTIFICATION_TYPES.map((notificationType) => [
      notificationType,
      EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPE_GROUPS.cancellations,
    ]),
  ),
  ...Object.fromEntries(
    EMAIL_DELIVERY_FAILURE_POST_PURCHASE_NOTIFICATION_TYPES.map((notificationType) => [
      notificationType,
      EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPE_GROUPS.postPurchase,
    ]),
  ),
  ...Object.fromEntries(
    EMAIL_DELIVERY_FAILURE_CONFIRMATION_NOTIFICATION_TYPES.map((notificationType) => [
      notificationType,
      EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPE_GROUPS.confirmations,
    ]),
  ),
  ...Object.fromEntries(
    EMAIL_DELIVERY_FAILURE_OTHER_NOTIFICATION_TYPES.map((notificationType) => [
      notificationType,
      EMAIL_DELIVERY_FAILURE_NOTIFICATION_TYPE_GROUPS.others,
    ]),
  ),
} as Record<EmailDeliveryFailureNotificationType, string>;

export const EMAIL_DELIVERY_FAILURE_RESOLUTION_TYPES = ['RESEND', 'FORWARD', 'IGNORED', 'ACTIONED_OFFLINE'] as const;

export type EmailDeliveryFailureResolutionType = (typeof EMAIL_DELIVERY_FAILURE_RESOLUTION_TYPES)[number];

export const EMAIL_DELIVERY_FAILURE_RESOLUTION_TYPE_LABELS: Record<EmailDeliveryFailureResolutionType, string> = {
  RESEND: 'Resend',
  FORWARD: 'Forward',
  IGNORED: 'Ignored',
  ACTIONED_OFFLINE: 'Actioned offline',
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
